import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ClaimTrainingModalComponent } from '../../modals/claim-training-modal/claim-training-modal.component';

@Injectable()
export class TrainingsUIService {
  constructor(
    private readonly modalGC: ModalController,
    private readonly alert: AlertController,
  ) {}

  showClaimTrainingModal() {
    return from(
      this.modalGC.create({
        component: ClaimTrainingModalComponent,
        cssClass: 'rounded-modal',
      }),
    ).pipe(
      switchMap(modal =>
        from(modal.present()).pipe(
          switchMap(() => modal.onDidDismiss()),
          map(({ role }) => ({ role })),
        ),
      ),
    );
  }

  confirmRemoveTrainingClaim() {
    return from(
      this.alert.create({
        header: 'Remove Training Claim',
        message: `Are you sure you want to remove this?`,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'button-text-dark',
          },
          {
            text: 'Remove',
            role: 'ok',
            cssClass: 'button-text-red',
          },
        ],
      }),
    ).pipe(
      switchMap(alert =>
        from(alert.present()).pipe(
          switchMap(() => alert.onDidDismiss()),
          map(({ role }) => ({ role })),
        ),
      ),
    );
  }
}
